import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@xingternal/button';

import { Styles } from './header-logged-out.styles';
import { getLoginLink } from './utils/get-login-link';

type HeaderLoggedOutProps = {
  className?: string;
  hideLoginButton?: boolean;
  hideSignupButton?: boolean;
  homeLink?: string;
  loginLink?: string;
  signupLink?: string;
};

const HeaderLoggedOut: React.FC<HeaderLoggedOutProps> = ({
  className,
  hideLoginButton,
  hideSignupButton,
  homeLink,
  loginLink = getLoginLink(),
  signupLink = '/start/signup',
}) => {
  const { formatMessage } = useIntl();
  return (
    <Styles.StyledPlacebo className={className}>
      <Styles.StyledHeaderWrapper>
        <Styles.StyledHeader>
          <Styles.StyledLogoWrapper>
            <Styles.StyledLogo
              butterfly
              homeLink={homeLink}
              dataQa="logoMobile"
              size={28}
            />
            <Styles.StyledLogo
              variant="duo"
              size={96}
              homeLink={homeLink}
              dataQa="logo"
            />
          </Styles.StyledLogoWrapper>

          {!(hideLoginButton && hideSignupButton) && (
            <Styles.StyledNav data-qa="loggedin-nav">
              {!hideLoginButton && (
                <React.Fragment>
                  {hideSignupButton ? (
                    <Button
                      data-testid="Styled-Login-Button"
                      size="medium"
                      href={loginLink}>
                      {formatMessage({
                        id: 'X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK',
                      })}
                    </Button>
                  ) : (
                    <Styles.StyledLoginTextButton
                      data-testid="Styled-Login-Button"
                      size="medium"
                      href={loginLink}>
                      {formatMessage({
                        id: 'X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK',
                      })}
                    </Styles.StyledLoginTextButton>
                  )}
                </React.Fragment>
              )}
              {!hideSignupButton && (
                <Button
                  data-testid="Styled-Signin-Button"
                  size="medium"
                  variant="primary"
                  href={signupLink}>
                  {formatMessage({ id: 'X_UI_HEADER_REGISTER' })}
                </Button>
              )}
            </Styles.StyledNav>
          )}
        </Styles.StyledHeader>
      </Styles.StyledHeaderWrapper>
    </Styles.StyledPlacebo>
  );
};

export { HeaderLoggedOut };
